<div class="shadow-lg py-4 px-2 items-center">
    <div class="flex gap-3 justify-around">
      <mat-form-field class="">
        <mat-label>Warehouse</mat-label>
        <mat-select class=" ">
          <mat-option [value]="0">option 1</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Start Date</mat-label>
        <mat-select class="  ">
          <mat-option [value]="0">option 1</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>End Date</mat-label>
        <mat-select class="  ">
          <mat-option [value]="0">option 1</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex justify-end gap-3">
      <button>ok</button>
      <button>cancel</button>
    </div>
</div>
